// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"SaveSearchModal_modalHeader_1ah54y2","cancelButton":"SaveSearchModal_cancelButton_3Kcb0jT","applyButton":"SaveSearchModal_applyButton_yYpi-SR"};